import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { NavLink, useLocation } from "react-router-dom";
import MemberShipForm from "./MemberShipForm";
import { Helmet } from "react-helmet";

const ContactUs = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#membership-form") {
      const mapElement = document.getElementById("membership-form");
      if (mapElement) {
        mapElement.scrollIntoView({ behavior: "auto" });
      }
    }
  }, [location]);

  useEffect(() => {
    if (location.hash === "#overview") {
      const mapElement = document.getElementById("overview");
      if (mapElement) {
        mapElement.scrollIntoView({ behavior: "auto" });
      }
    }
  }, [location]);


  useEffect(() => {
    if (location.hash === "#RegulatoryComplianceSupport") {
      const mapElement = document.getElementById("RegulatoryComplianceSupport");
      if (mapElement) {
        mapElement.scrollIntoView({ behavior: "auto" });
      }
    }
  }, [location]);

  useEffect(() => {
    if (location.hash === "#RiskManagementAssistance") {
      const mapElement = document.getElementById("RiskManagementAssistance");
      if (mapElement) {
        mapElement.scrollIntoView({ behavior: "auto" });
      }
    }
  }, [location]);

  useEffect(() => {
    if (location.hash === "#BankingRelationshipAdvocacy") {
      const mapElement = document.getElementById("BankingRelationshipAdvocacy");
      if (mapElement) {
        mapElement.scrollIntoView({ behavior: "auto" });
      }
    }
  }, [location]);

  useEffect(() => {
    if (location.hash === "#TechnologicalSupport") {
      const mapElement = document.getElementById("TechnologicalSupport");
      if (mapElement) {
        mapElement.scrollIntoView({ behavior: "auto" });
      }
    }
  }, [location]);

  useEffect(() => {
    if (location.hash === "#AdvocacyandRepresentation") {
      const mapElement = document.getElementById("AdvocacyandRepresentation");
      if (mapElement) {
        mapElement.scrollIntoView({ behavior: "auto" });
      }
    }
  }, [location]);
    const headingVariants = {
        hidden: { opacity: 0, x: 50 },
        visible: (i) => ({
          opacity: 1,
          x: 0,
          transition: {
            delay: i * 0.1, // Delay for each letter
            type: "spring",
            stiffness: 120,
          },
        }),
      };
  const headingText = "Benefits of Membership ";
 
  useEffect(() => {
    let previousHighlightedId = null; // Keep track of the last highlighted ID
  
    const highlightElement = (id) => {
      const element = document.getElementById(id);
  
      if (element) {
        // Reset the previously highlighted element
        if (previousHighlightedId && previousHighlightedId !== id) {
          const prevElement = document.getElementById(previousHighlightedId);
          if (prevElement) {
            prevElement.classList.remove("highlight");
            prevElement.classList.add("fade-out");
            setTimeout(() => {
              prevElement.classList.remove("fade-out");
            }, 2000); // Remove fade-out after animation completes
          }
        }
  
        // Highlight the current element
        // element.classList.add("highlight");
        setTimeout(() => {
          element.classList.remove("highlight");
          element.classList.add("fade-out");
          setTimeout(() => {
            element.classList.remove("fade-out");
          }, 2000); // Remove fade-out after animation completes
        }, 2000); // Highlight duration
  
        // Highlight the next element (if it exists)
        const allElements = Array.from(document.querySelectorAll("[id]"));
        const currentIndex = allElements.findIndex((el) => el.id === id);
  
        if (currentIndex !== -1 && currentIndex + 1 < allElements.length) {
          const nextElement = allElements[currentIndex + 1];
          nextElement.classList.add("highlight");
          setTimeout(() => {
            nextElement.classList.remove("highlight");
            nextElement.classList.add("fade-out");
            setTimeout(() => {
              nextElement.classList.remove("fade-out");
            }, 2000);
          }, 2000); // Highlight duration
        }
  
        // Update the previously highlighted ID
        previousHighlightedId = id;
      }
    };
  
    if (location.hash) {
      const hashId = location.hash.substring(1); // Remove '#' from the hash
      highlightElement(hashId);
    }
  }, [location]);
 
      const title = "Overview";

      const letterVariants = {
        hidden: { y: -50, opacity: 0 },
        visible: (index) => ({
          y: 0,
          opacity: 1,
          transition: {
            delay: index * 0.1, // Delay each letter animation
            duration: 0.4,
            ease: "easeInOut",
          },
        }),
    }
  return (
    <div>
      <Helmet>
          {/* Basic Meta Tags */}
          <title> Join MSB Association | MSB Association Membership Benefits</title>
          <meta
            name="description"
            content="Join MSB Association and unlock exclusive membership benefits, including compliance support, banking access, fraud prevention resources, and industry advocacy for MSB."
          />
    

          {/* Open Graph Meta Tags */}
          <meta property="og:title" content="Join MSB Association | MSB Association Membership Benefits " />
          <meta
            property="og:description"
            content="Join MSB Association and unlock exclusive membership benefits, including compliance support, banking access, fraud prevention resources, and industry advocacy for MSB."
          />

        <meta
          property="og:image"
          content="https://msbassociationuk.org/assets/images/logo.svg"
        />

          <meta property="og:type" content="website" />

          {/* Twitter Meta Tags */}
        </Helmet>
<main className="page_content">
  {/* Page Header - Start
================================================== */}
  <section id="overview" className="page_header text-center  section_decoration overflow-hidden" style={{background: "#333"}}>
    <div className="container">
    <motion.h1
        className="page_title text-white"
        initial="hidden"
        animate="visible"
        style={{ display: "flex", justifyContent: "center" }}
      >
        {title.split("").map((letter, index) => (
          <motion.span
            key={index}
            custom={index}
            variants={letterVariants}
            style={{ display: "inline-block", marginRight: letter === " " ? "0.3rem" : "0" }}
          >
            {letter}
          </motion.span>
        ))}
      </motion.h1>
      <ul className="breadcrumb_nav unordered_list justify-content-center">
        <li><NavLink to="/">Home</NavLink></li>
        <li className="active"><a href="#!">Overview</a></li>
      </ul>
    </div>
   
  
    
  </section>
  {/* Page Header - End
================================================== */}
  {/* Contact Section - Start
================================================== */}
  <section className="contact_section section_space bg-dark">


   <div className="container">
 
  <div className="item_details_content">
    <h2 className="item_details_heading" >
              {headingText.split("").map((char, i) => (
              <motion.span
                key={`${char}-${i}`}
                custom={i}
                initial="hidden"
                animate="visible"
                variants={headingVariants}
              >
                {char}
              </motion.span>
            ))}
              </h2>
    <p >
    Becoming a member of the MSB Association offers numerous advantages that can help your Money Service Business thrive in a competitive environment. Here are some key benefits:
    </p>

    <h5 className="mb-3" id="RiskManagementAssistance">Regulatory Compliance Support</h5>
    <p>
    1. Expert guidance from Ex- FCA and Ex- HMRC staff
    </p>
    <p>2. Support in preparing for regulatory visits, including guidance on documentation</p>
    <p>3. Regulatory updates</p>
    <p>4. Workshops and Seminars from industry experts</p>
   
    <hr />

    <h5 className="mb-3" id="BankingRelationshipAdvocacy">Risk Management Assistance</h5>
    <p>1. Training Programmes to know best practices to safeguard your business</p>
    <p>2. Information and access to tools that will help you to mitigate risks</p>
    <hr />
    <h5 className="mb-3" id="TechnologicalSupport">Banking Relationship Advocacy</h5>
    <p>1. Support for Sudden Account Closures by providing strategies to minimise the disruptions</p>
    <p>2. Addressing fund delays by providing proper channel and effectively communicating with the banks</p>
    <p>3. Referral to trusted banking partners who can offer reliable and sustainable bank accounts</p>
    <p>4. Experience and solutions sharing with the members facing similar banking challenges</p>
    <hr />
    <h5 className="mb-3 " id="AdvocacyandRepresentation">Technological Support</h5>
    <p>1. Get insights on the latest technology and innovation</p>
    <p>2. Consultation on getting access to right tools </p>
    <p>3. Benefits from partnerships with technology providers</p>
    <hr />
    <h5 className="mb-3" id="AdvocacyandRepresentation2"> Advocacy and Representation</h5>
    <p>1. Get a voice by actively engaging with the regulators and policymakers</p>
    <hr />
    


   
  </div>
</div>

  </section>

<div id="membership-form">
<MemberShipForm />
</div>


</main>

    </div>
  )
}

export default ContactUs
